/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetCorporationsCorporationIdBookmarksFolders200Ok
 */
export interface GetCorporationsCorporationIdBookmarksFolders200Ok {
    /**
     * creator_id integer
     * @type {number}
     * @memberof GetCorporationsCorporationIdBookmarksFolders200Ok
     */
    creatorId?: number;
    /**
     * folder_id integer
     * @type {number}
     * @memberof GetCorporationsCorporationIdBookmarksFolders200Ok
     */
    folderId: number;
    /**
     * name string
     * @type {string}
     * @memberof GetCorporationsCorporationIdBookmarksFolders200Ok
     */
    name: string;
}

/**
 * Check if a given object implements the GetCorporationsCorporationIdBookmarksFolders200Ok interface.
 */
export function instanceOfGetCorporationsCorporationIdBookmarksFolders200Ok(value: object): value is GetCorporationsCorporationIdBookmarksFolders200Ok {
    if (!('folderId' in value) || value['folderId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function GetCorporationsCorporationIdBookmarksFolders200OkFromJSON(json: any): GetCorporationsCorporationIdBookmarksFolders200Ok {
    return GetCorporationsCorporationIdBookmarksFolders200OkFromJSONTyped(json, false);
}

export function GetCorporationsCorporationIdBookmarksFolders200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCorporationsCorporationIdBookmarksFolders200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'creatorId': json['creator_id'] == null ? undefined : json['creator_id'],
        'folderId': json['folder_id'],
        'name': json['name'],
    };
}

export function GetCorporationsCorporationIdBookmarksFolders200OkToJSON(json: any): GetCorporationsCorporationIdBookmarksFolders200Ok {
    return GetCorporationsCorporationIdBookmarksFolders200OkToJSONTyped(json, false);
}

export function GetCorporationsCorporationIdBookmarksFolders200OkToJSONTyped(value?: GetCorporationsCorporationIdBookmarksFolders200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'creator_id': value['creatorId'],
        'folder_id': value['folderId'],
        'name': value['name'],
    };
}

